import { DefaultValue } from '@billy/design-system'
import styled from '@emotion/styled'

export const IconWrapper = styled.img`
  width: 32px;
  max-height: 32px;
  border-radius: ${DefaultValue.BorderRadius};
`
